import { render } from "./Especialidades.vue?vue&type=template&id=35d744c5&scoped=true"
import script from "./Especialidades.vue?vue&type=script&lang=js"
export * from "./Especialidades.vue?vue&type=script&lang=js"

import "./Especialidades.vue?vue&type=style&index=0&id=35d744c5&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d744c5"]])

export default __exports__